import { config } from '#core/config/env.ts';
import type { UserType } from '#domain/user/user.schema.ts';
import { productFruits } from 'product-fruits';

export const useProductFruits = (user: UserType) => {
  if (navigator.webdriver) {
    console.info('Product Fruits not enabled. Skipping ...');
    return;
  }
  if (!config.productFruitsWorkspace) {
    console.error('Product Fruits workspace id is not supplied. Skipping ...');
    return;
  }
  productFruits.init(config.productFruitsWorkspace, user.country ?? 'en', {
    email: user.email ?? '',
    username: user.email ?? ''
  });
};
